import { render, staticRenderFns } from "./CorporateAccounts.vue?vue&type=template&id=51d87a16&scoped=true&"
import script from "./CorporateAccounts.vue?vue&type=script&lang=js&"
export * from "./CorporateAccounts.vue?vue&type=script&lang=js&"
import style0 from "./CorporateAccounts.vue?vue&type=style&index=0&id=51d87a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d87a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d87a16')) {
      api.createRecord('51d87a16', component.options)
    } else {
      api.reload('51d87a16', component.options)
    }
    module.hot.accept("./CorporateAccounts.vue?vue&type=template&id=51d87a16&scoped=true&", function () {
      api.rerender('51d87a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/CorporateAccounts.vue"
export default component.exports